<template>
  <div class="con-pro-painel">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div v-if="[ '', null, undefined ].indexOf(placar) === -1" class="con-pro-painel-pla">
        <template v-for="(vetor, index2) in placar">
          <App-Button :key="'lista-bt--' + index2" class="btn btn-default" :class="mostrarPlacar.indexOf(vetor.id) !== -1 ? 'active' : ''" @onClick="() => { conProPainelAbrirPainel(vetor.id) }">
            {{ vetor.nome }} ({{ vetor.qtde }})
          </App-Button>
        </template>

        <table v-if="mostrarPlacar.length >= 1">
          <tr v-for="chaveV in mostrarPlacar" :key="'bt-placar--' + chaveV">
            <td>
              {{ placar[chaveV].nome }}
            </td>

            <td v-for="(vetor, index) in placar[chaveV].tabela" :style="'background: ' + vetor.cor_fundo + ' !important; color: ' + vetor.cor_letra + ';'" :key="'td-placar--' + index">
              {{ vetor.nome }}
              <br/>
              <b>{{ vetor.qtde }}</b>
            </td>
          </tr>
        </table>
      </div>

      <table class="con-pro-painel-fil">
        <tr>
          <td class="botoes">
            <RF-Tabela-Minha-Personalizacao v-if="mPer !== null"
            :cpntTime='time'
            :cpntId='"pco-painel-mper"'
            :cpntMper='mPer'
            :cpntOnRefreshTabela='() => { conProPainelMperIniciar(() => { conProPainelReiniciar() })}'
            ></RF-Tabela-Minha-Personalizacao>

            <App-Button @onClick="() => { conProPainelAbrirDetalhe('venda') }">
              Cliente / Nº Vendas
            </App-Button>
            <App-Button v-if="permissoes.produto === true" @onClick="() => { conProPainelAbrirDetalhe('produto') }">
              Produto / Qtde
            </App-Button>
            <App-Button v-if="permissoes.servico === true" @onClick="() => { conProPainelAbrirDetalhe('servico') }">
              Serviço / Qtde
            </App-Button>
          </td>
          <td class="filtros">
            <div class="app-fil-rel-nov">
              <table>
                <tr class="n-col-3">
                  <td>
                    <App-Filtro-Relatorio
                    :cpntTipo="'select'"
                    :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
                    :cpntKeyValue="'id'"
                    :cpntKeyMostra="[ 'nome', ' (',  'qtde', ')']"
                    :cpntNome="'Lista'"
                    :cpntTodos="'Todos'"
                    :cpntValue="filtros.lista"
                    :cpntNenhum="null"
        
                    :cpntOnBuscarOptions="conProPainelBuscarLista"
                    @UPDATE_VALUE_FILTRO="(value) => { conProPainelAtualizarFiltro(value, 'lista') }"
                    ref="lista"
                    ></App-Filtro-Relatorio>
                  </td>
      
                  <td>
                    <App-Filtro-Relatorio
                    :cpntTipo="'select'"
                    :cpntTabela="[ { nome: 'Nome', chave: 'nome' } ]"
                    :cpntKeyValue="'id'"
                    :cpntKeyMostra="[ 'nome', ' (',  'qtde', ')']"
                    :cpntNome="'Status'"
                    :cpntTodos="'Todos'"
                    :cpntValue="filtros.status"
                    :cpntNenhum="null"
        
                    :cpntOnBuscarOptions="conProPainelBuscarStatus"
                    @UPDATE_VALUE_FILTRO="(value) => { conProPainelAtualizarFiltro(value, 'status') }"
                    ref="status"
                    ></App-Filtro-Relatorio>
                  </td>
                <!-- </tr>
                <tr class="n-col-1"> -->
                  <td class="busca">
                    <span style="display: inline-block; vertical-align: 10px;">Busca:&nbsp;</span>
                    <App-Filtro-Relatorio style="display: inline-block;"
                    :cpntTipo="'input'"
                    :cpntValue="filtros.busca"
                    :cpntNenhum="null"
                    :cpntNome="''"              
                    @UPDATE_VALUE_FILTRO="(value) => { conProPainelAtualizarFiltro(value, 'busca') }"
                    @cpntOnKeyPressEnter="() => { conProPainelReiniciar() }"
                    ref="busca"
                    ></App-Filtro-Relatorio>
      
                    <div title="Selecione caso deseje que a busca contenha toda a Frase Digitada" class="cpnt-fil-rel--nenhum" style="display: inline-block; vertical-align: 10px;">
                      <input :id='"input-busca-con-pro-painel" + "--checkbox"' type="checkbox" class="app-checkbox" v-model="filtros.buscacompleta" />
                      <label :for='"input-busca-con-pro-painel" + "--checkbox"'></label>
                    </div>
                  </td>

                  <td style="border: none; padding: 0px;">
                    <App-Button class :cpntIcone="'fa fa-search'" style="width: 34px; height: 34px; background: #337ab7; border: 1px solid #2e6da4; cursor: pointer; color: #fff;" @onClick="conProPainelReiniciar"></App-Button>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </table>
      <span style="clear: both;"></span>

      <div class="con-pro-painel-tab" :key="JSON.stringify(dados)">
        <table>
          <caption v-if="mascara === true">
            &nbsp;
          </caption>
          <tr v-for="(linha, indexL) in dados" :style="([ '', null, undefined ].indexOf(linha.id_pco_status_item_cor) === -1 ? (' background: ' + linha.id_pco_status_item_cor + ';') : '') + ([ '', null, undefined ].indexOf(linha.id_pco_status_item_cor_letra) === -1 ? (' color: ' + linha.id_pco_status_item_cor_letra + ';') : '')" :key="'tr--' + indexL">
            <td class="venda">              
              <App-Button
              :cpntClass="(linha.cod_venda_status === '2' ? [ 'btn', 'btn-sm', 'btn-primary' ] : [ 'btn', 'btn-sm', 'btn-warning' ])"
              @onClick='() => { conProPainelAbrirVenda(linha.cod_venda) }'>
                <div v-html="(linha.cod_venda_status === '2' ? 'V' : 'O') + ' ' + (linha.cod_venda.length <= 4 ? ('0000' + linha.cod_venda).slice(-4) : linha.cod_venda)"></div>
              </App-Button>

              <!-- SETA O BOTÃO PARA ADICIONAR PRODUTO -->
              <div>
                <App-Button v-if="permissoes.produto === true" :cpntClass="'btn btn-sm btn-default'" cpntIcone="mais" cpntTexto="Produto" @onClick='() => { conProPainelAdicionarItemVendaIniciar(linha.cod_venda, "produto") }'></App-Button>
  
                <!-- SETA O BOTÃO PARA ADICIONAR SERVIÇO -->
                <App-Button v-if="permissoes.servico === true" :cpntClass="'btn btn-sm btn-default'" cpntIcone="mais" cpntTexto="Serviço" @onClick='() => { conProPainelAdicionarItemVendaIniciar(linha.cod_venda, "servico") }'></App-Button>
              </div>
            </td>

            <td class="dados">
              <table>
                <tr class="linha-itens-1">
                  <td class="data" :style="[ '', null, undefined ].indexOf(mPer.mostrarCol) !== -1 || mPer.mostrarCol.indexOf('dt_venda') === -1 ? 'visibility: hidden;' : ''">
                    <div>Dt. Venda:&nbsp;</div>
                    <div class="font-tp-1" v-html="linha.cod_venda_dt_ent_ptbr"></div>
                  </td>
                  <td class="data" :style="[ '', null, undefined ].indexOf(mPer.mostrarCol) !== -1 || mPer.mostrarCol.indexOf('dt_vcto') === -1 ? 'visibility: hidden;' : ''">
                    <div>Vencimento:&nbsp;</div>
                    <div class="font-tp-1" v-html="linha.cod_venda_vencimento_ptbr"></div>
                  </td>
                  <td class="contato">
                    Contato:<br/>
                    <App-Button :cpntClass="'btn btn-default bt-link-cadastro'" @onClick='() => { conProPainelAbrirContato(linha.cod_venda_id_con) }'>
                    <!-- COLOCA O NOME DO CONTATO -->
                    <span v-html="linha.cod_venda_id_con_nome"></span>

                    <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
                    <span v-if='linha.cod_venda_id_con_pessoa === "j" && linha.cod_venda_id_con_empresa !== ""' v-html="' (' + linha.cod_venda_id_con_empresa + ')'"></span>

                    <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                    <b v-if='linha.cod_venda_id_con_status !== "1"' v-html="'[Excluído]'"></b>
                    </App-Button>
                  </td>
                  
                  <td class="veiculo" :style="[ '', '0' ].indexOf(linha.cod_venda_id_vei) !== -1 ? 'visibility: hidden;' : ''">
                    Veículo:<br/>
                    <App-Button :cpntClass="'btn btn-default bt-link-cadastro'" @onClick='() => { conProPainelAbrirVeiculo(linha.cod_venda_id_vei) }'>
                    <!-- COLOCA O NOME DO VEICULO -->
                    <span v-html="linha.cod_venda_id_vei_placa"></span>

                    <!-- COLOCA O MODELO NOVO DA API -->
                    <template v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_vei_marca) === -1 || [ '', null, undefined ].indexOf(linha.cod_venda_id_vei_modelo) === -1">
                      <span v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_vei_marca) === -1" v-html="' ' + linha.cod_venda_id_vei_marca"></span>
                      <span v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_vei_modelo) === -1" v-html="' ' + linha.cod_venda_id_vei_modelo"></span>
                    </template>

                    <!-- COLOCA O MODELO ANTIGO DA API-->
                    <template v-else>
                      <span v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_vei_marca_antigo) === -1" v-html="' ' + linha.cod_venda_id_vei_marca_antigo"></span>
                      <span v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_vei_modelo_antigo) === -1" v-html="' ' + linha.cod_venda_id_vei_modelo_antigo"></span>
                    </template>

                    <!-- VERIFICA SE O VEICULO ESTA EXCLUIDO -->
                    <b v-if='linha.cod_venda_id_vei_status !== "1"' v-html="'[Excluído]'"></b>
                    </App-Button>
                  </td>

                  <td class="pet" :style="[ '', '0' ].indexOf(linha.cod_venda_id_pet) !== -1 ? 'visibility: hidden;' : ''">
                    Pet:<br/>
                    <App-Button :cpntClass="'btn btn-default bt-link-cadastro'" @onClick='() => { conProPainelAbrirPet(linha.cod_venda_id_pet) }'>
                    <!-- COLOCA O NOME DO PET -->
                    <span v-html="linha.cod_venda_id_pet_nome"></span>

                    <!-- COLOCA O NOME DO PET -->
                    <span v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_pet_subespecie_nome) === -1" v-html="' (' + linha.cod_venda_id_pet_subespecie_nome + ')'"></span>

                    <!-- VERIFICA SE O PET ESTA EXCLUIDO -->
                    <b v-if='linha.cod_venda_id_pet_status !== "1"' v-html="'[Excluído]'"></b>
                    </App-Button>

                    <!-- SETA A OBSERVAÇÃO -->
                    <div v-if="[ '', null, undefined ].indexOf(linha.cod_venda_id_pet_obs) === -1" class="pet-obs">
                      <!-- SETA O CAMPO TEXTO -->
                      <div>Obs: <span v-html="linha.cod_venda_id_pet_obs_tela"></span></div>
                      
                      <!--  SETA O BOTÃO PARA MOSTRAR O CARREGAR MAIS -->
                      <App-Button v-if="linha.cod_venda_id_pet_obs_mostrar_bt === true" :cpntClass="'btn btn-default btn-sm'" @onClick='() => { conProPainelAlterarObservaçãoPet(indexL) }'>Mostrar mais</App-Button>
                    </div>
                  </td>
                </tr>
                
                <tr :data-time="time" v-if="[ '', null, undefined ].indexOf(linha.itens) === -1 && linha.itens.length >= 1">
                  <td class="itens" :colspan="conProPainelCalcularColspanTabelaItens(linha)">
                    <table>
                      <tr :data-time="time" v-for="(item, indexI) in linha.itens" :key="'ven-' + linha.cod_venda + '-' + indexI + '-' + item.id + '-index-' + indexI" :style="([ '', null, undefined ].indexOf(item.id_pco_status_item_cor) === -1 ? (' background: ' + item.id_pco_status_item_cor + ';') : '') + ([ '', null, undefined ].indexOf(item.id_pco_status_item_cor_letra) === -1 ? (' color: ' + item.id_pco_status_item_cor_letra + ';') : '')">
                        <td class="item" >
                          <span style="margin-right: 5px; ">
                            <img src="./12.0.png" v-if="[ '', null, undefined ].indexOf(item.id_ven_pro) === -1" title="Produto" />
                            <img src="./21.1.png" v-if="[ '', null, undefined ].indexOf(item.id_ven_ser) === -1" title="Serviço" />
                          </span>
                          <!-- ({{ item.id_ven_pro }})
                          ({{ item.id_ven_ser }})
                          ({{ item }}) -->
                          <template v-if="[ '', null, undefined ].indexOf(item.id_ven_pro) === -1">
                            <App-Button :cpntIcone='"produto"' :cpntClass="'btn btn-default bt-link-cadastro'" @onClick='() => { conProPainelAbrirProduto(item.id_ven_pro_id_pro) }'>
                              <!-- COLOCA O NOME DO CONTATO -->
                              <span v-html="item.id_ven_pro_id_pro_nome"></span>

                              <!-- VERIFICA SE O PRODUTO ESTA EXCLUIDO -->
                              <b v-if='item.id_ven_pro_id_pro_status !== "1"' v-html="'[Excluído]'"></b>
                            </App-Button>
                          </template>
                          <template v-else-if="[ '', null, undefined ].indexOf(item.id_ven_ser) === -1">
                            <App-Button :cpntIcone='"produto"' :cpntClass="'btn btn-default bt-link-cadastro'" @onClick='() => { conProPainelAbrirServico(item.id_ven_ser_id_ser) }'>
                              <!-- COLOCA O NOME DO CONTATO -->
                              <span v-html="item.id_ven_ser_id_ser_nome"></span>

                              <!-- VERIFICA SE O SERVIÇO ESTA EXCLUIDO -->
                              <b v-if='item.id_ven_ser_id_ser_status !== "1"' v-html="'[Excluído]'"></b>
                            </App-Button>
                          </template>
                        </td>
                        
                        <template v-if="[ '', null, undefined ].indexOf(mPer.mostrarCol) === -1 && mPer.mostrarCol.indexOf('qtde') !== -1">
                          <td class="qtde" v-if="[ '', null, undefined ].indexOf(item.id_ven_pro_qtde) === -1">
                            <div class="font-tp-1">
                              <span v-html="item._id_ven_pro_qtde" title="Quanidade de produto inserida na venda."></span>
                            </div>
                          </td>

                          <td class="qtde" v-else if="[ '', null, undefined ].indexOf(item.id_ven_ser_qtde) === -1">
                            <div class="font-tp-1">
                              <span v-html="item._id_ven_ser_qtde" title="Quanidade de serviço inserida na venda."></span>
                            </div>
                          </td>
                        </template>

                        <!-- <td class="insumo" :style="item.id_ven_pro_fabricado === 's' ? '' : 'border-left: none;'">
                          <span v-if="item.id_ven_pro_fabricado === 's' && [ '', null, undefined ].indexOf(item.id_ven_pro) === -1">
                            <RF-Button
                              :cpntId="'RF-Tabela-Vue--link-pco_item--insumo--' + indexV + '--' + indexI"
                              :cpntStatus='""'
                              :cpntTipo='"icone"'
                              :cpntIcone="{ tipo: 'insumo' }"
                              :cpntClass='[ "btn", "btn-default", "btn-sm", "btn-default" ]'
                              :cpntExplica="{ titulo: '', mensagem: 'Clique aqui para verificar a produção deste item' }"

                              @onClick='conProPainelInformacoesProducao(venda.cod_venda, item.id_ven_pro)'>
                            </RF-Button>
                          </span>
                        </td> -->

                        <td class="status">
                          <div class="font-tp-1">
                            <span v-html="item.id_pco_status_item_nome"></span>
                            <App-Icone :title="[ '', null, undefined ].indexOf(item.tempo) === -1 ? item.tempo : conProPainelAtualizarData(indexL, indexI)" :cpntTipo="'relogio_preto'"></App-Icone>
                          </div>
                        </td>
                        
                        <td class="comentario" v-if="[ '', null, undefined ].indexOf(mPer.mostrarCol) === -1 && mPer.mostrarCol.indexOf('comentarios_pro') !== -1" :style="([ '', null, undefined ].indexOf(item.obs) === -1 && item.obs.length >= 1 ? '' : 'vertical-align: middle; text-align: center;')">
                          <template v-if="[ '', null, undefined ].indexOf(item.obs) === -1 && item.obs.length >= 1">
                            <div v-for="(obs, indexO) in item.obs" :key="'ven-' + item.cod_venda + '-' + indexI + '-' + item.item_id + '-index-' + indexI + '-obs-' + indexO">
                              <!-- ADICIONA A ALTERAÇÃO -->
                              <div v-html="'Alterado por ' + obs.last_user + ' em ' + obs.last_at_ptbr + ': '"></div>

                              <!-- ADICIONA A OBSERVAÇÃO -->
                              <div v-html="obs.observacao"></div>
                            </div>
                          </template>
                          <div v-else>---</div>
                        </td>

                        <td class="editar">
                          <App-Button :cpntIcone='"editar"' :cpntClass="'btn btn-sm btn-warning'" @onClick='() => { conProPainelAbrirProcesso(([ "", null, undefined ].indexOf(item.id_ven_pro) === -1 ? item.id_ven_pro : item.id_ven_ser), ([ "", null, undefined ].indexOf(item.id_ven_ser) === -1 ? "servico" : "produto")) }'></App-Button>
                        </td>

                        <td class="editar-geral" v-if="indexI === 0" :rowspan="linha.itens.length" style="background: #e9e9e9;">
                          <template v-if="indexI === 0 && linha.itens.length >= 1 && linha.itens.filter(vetor => vetor.id_pco_status !== item.id_pco_status).length === 0">
                            <App-Button :cpntIcone='"editar"' :cpntClass="'btn btn-sm btn-primary'" @onClick='() => { conProPainelEditarGeralProcesso(linha.itens) }'></App-Button>
                          </template>
                          <template v-else>
                            <App-Button :cpntIcone='"editar"' :cpntClass="'btn btn-sm btn-primary'" :disabled="true" :title="'Não é possivel alterar varios registros ao mesmo tempo, pois tem lista de status diferente para está venda.'"></App-Button>
                          </template>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>

            <td class="status">
              <template v-if="[ '', null, undefined ].indexOf(linha.id_pco_status_item_nome) === -1">
                <div>
                  Status:
                  <App-Icone :title="[ '', null, undefined ].indexOf(linha.tempo) === -1 ? linha.tempo : conProPainelAtualizarData(indexL, indexI)" :cpntTipo="'relogio_preto'"></App-Icone>
                </div>
                <div class="font-tp-1">
                  <span v-html="linha.id_pco_status_item_nome"></span>
                </div>
              </template>
              <template v-else>
                <div>---</div>
              </template>
            </td>

            <td class="comentario" v-if="[ '', null, undefined ].indexOf(mPer.mostrarCol) === -1 && mPer.mostrarCol.indexOf('comentarios_ven') !== -1" :style="([ '', null, undefined ].indexOf(linha.obs) === -1 && linha.obs.length >= 1 ? '' : 'vertical-align: middle; text-align: center;')">
              <template v-if="[ '', null, undefined ].indexOf(linha.obs) === -1 && linha.obs.length >= 1">
                <div v-for="(obs, indexO) in linha.obs" :key="'ven-' + linha.cod_venda + '-obs-' + indexO">
                  <!-- ADICIONA A ALTERAÇÃO -->
                  <div v-html="'Alterado por ' + obs.last_user + ' em ' + obs.last_at_ptbr + ': '"></div>

                  <!-- ADICIONA A OBSERVAÇÃO -->
                  <div v-html="obs.observacao"></div>
                </div>
              </template>
              <div v-else>---</div>
            </td>

            <td class="editar">
              <App-Button :cpntIcone='"editar"' :cpntClass="'btn btn-warning'" @onClick='() => { conProPainelAbrirProcesso(linha.cod_venda, "venda") }'></App-Button>
            </td>
          </tr>
        </table>
      </div>

      <!-- SETA O ESPAÇO PARA RECEBER A TELA -->
      <router-view :cpntFecharFormulario="conProPainelInformacoesCadastroFechar"></router-view>

      <!-- ABRE A TELA PARA ADICIONAR OS ITENS -->
      <App-Demanda-Inserir-Item-Dialog v-if="[ '', null, undefined ].indexOf(adicionar) === -1" 
      :cpntDemanda="'venda'"
      :cpntDemandaId="adicionar.vendaId" 
      :cpntTipo="adicionar.tipo"
      :cpntFecharFormulario="conProPainelAdicionarItemVendaFechar"
    ></App-Demanda-Inserir-Item-Dialog>

      <App-Controle-Processo-Painel-Detalhe-Tipo v-if="[ '', null, undefined ].indexOf(detalhe) === -1" 
      :cpntTipo="detalhe"
      :cpntDados="dados"
      :cpntOnFecharDialog="() => { conProPainelAbrirDetalhe(null) }"
      ></App-Controle-Processo-Painel-Detalhe-Tipo>

      <App-Controle-Processo-Editar-Varios v-if="pco_editar !== null"
      :cpntIds="pco_editar.ids"
      :cpntTipo="pco_editar.tipo"
      :cpntFecharFormulario="conProPainelFecharAlteracaoProcesso"
      ></App-Controle-Processo-Editar-Varios>
    </template>
  </div>
</template>

<style scoped>
  .con-pro-painel-pla {
    text-align: center
  }
    .con-pro-painel-pla > button {
      margin: 10px 10px 5px 10px;
    }
    .con-pro-painel-pla > table {
      width: auto;
      margin: 0 auto;
      margin-bottom: 10px;
      border-collapse: separate;
      border-spacing: 2px 1.5px;
    }
      .con-pro-painel-pla > table > tr > td {
        border: 1px solid #ccc;
      }
      .con-pro-painel-pla > table > tr > td:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      .con-pro-painel-pla > table > tr > td:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      .con-pro-painel-pla > table > tr > td:not(:first-child) {
        padding: 5px;
        min-width: 150px;
      }
      .con-pro-painel-pla > table > tr > td:first-child {
        /* border: 1px solid #e9e9e9; */
        padding: 5px;
        min-width: 130px;
        text-align: left;
        font-weight: bold
      }
    /* .placar>table>tr>td[data-v-0e8f1479]:first-child {
        text-align: left;
        padding-left: 10px;
    }
    .placar>table>tr>td[data-v-0e8f1479] {
        border: 1px solid #e9e9e9;
        padding: 5px;
        min-width: 150px; */

  .con-pro-painel-fil {
    width: 100% !important;
  }
    .con-pro-painel-fil > tr > td.filtros {
      text-align: right;
    }
    .con-pro-painel-fil > tr > td.filtros > span {
      float: right
    }
    .con-pro-painel-fil > tr > td.botoes {
      text-align: left;
      vertical-align: bottom
    }
      .con-pro-painel-fil > tr > td.botoes > button {
        margin-right: 5px;
        min-width: 90px;
      }

.app-fil-rel-nov {
  width: 800px;
  float: right;
}
  .app-fil-rel-nov > table > tr > td.busca > .cpnt-fil-rel {
    width: calc(100% - 70px);
  }

.con-pro-painel > .con-pro-painel-tab > table {
  width: 100% !important;
  border-collapse: separate;
  border-spacing: 0px 2px;
}

.con-pro-painel > .con-pro-painel-tab > table {
  position: relative;
}
  .con-pro-painel > .con-pro-painel-tab > table > caption {
    background: #fefefe;
    opacity: 0.6;
    z-index: 999;
    /* border: 1px solid #000; */

    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
    /* margin-top: -83px; */
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td {
    padding: 5px 2px;
    /* vertical-align: top !important; */
    text-align: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  .con-pro-painel > .con-pro-painel-tab > table > tr > td:first-child {
    border-left: 1px solid #ccc;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td:last-child {
    border-right: 1px solid #ccc;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  /* COLUNA = DADOS */
  .con-pro-painel > .con-pro-painel-tab > table > tr > td.dados {
    text-align: center;
    width: 61% !important;
  }

  /* COLUNA = VENDA */
  .con-pro-painel > .con-pro-painel-tab > table > tr > td.venda {
    text-align: center;
    width: 7% !important;
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td.venda > div {
    margin-top: 3px;
  }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td.venda > div > button,
    .con-pro-painel > .con-pro-painel-tab > table > tr > td.venda > button {
      margin: 0px auto;
      margin-top: 2px;
      width: 93% !important;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td.venda > div > button {
      padding-left: 8px;
      text-align: left;
    }
  
  /* COLUNA = STATUS */
  .con-pro-painel > .con-pro-painel-tab > table > tr > td.status {
    text-align: center;
    width: 13% !important;
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.status {
    text-align: center;
    width: 22% !important;
  }

  /* COLUNA = COMENTARIO */
  .con-pro-painel > .con-pro-painel-tab > table > tr > td.comentario {
    width: 15% !important;
    text-align: left;
    vertical-align: top;
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.comentario {
    width: 25% !important;
    text-align: left;
    vertical-align: top;
  }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td.comentario > div:not(:first-child),
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.comentario > div:not(:first-child) {
      margin-top: 7px;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td.comentario > div > div:first-child,
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.comentario > div > div:first-child {
      font-size: var(--font-base-soma-09);
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td.comentario > div > div:last-child,
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.comentario > div > div:last-child {
      padding-top: 2px;
      padding-left: 5px;
    }

  /* COLUNA = EDITAR */
  .con-pro-painel > .con-pro-painel-tab > table > tr > td.editar {
    text-align: center !important;
    width: 4% !important;
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.editar {
    text-align: center !important;
    width: 6% !important;
  }
  .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.editar-geral {
    text-align: center !important;
    width: 6% !important;
  }
  
  /* COLUNA = ITENS */
  .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.itens {
    width: 100% !important;
    background: #fff;
    padding: 0px 2px;
    border-radius: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.itens > table > tr > td.item {
      text-align: left;
      padding-left: 5px;
      padding-right: 5px;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.itens > table > tr > td.item {
      /* width: 42% !important; */
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.itens > table > tr > td.qtde {
      text-align: center !important;
      width: 5% !important;
    }
 
  .con-pro-painel > .con-pro-painel-tab > table > tr > td > table {
    width: 100% !important;
    border-collapse: separate;
    border-spacing: 0px 2px;
  }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td {
      /* vertical-align: top !important; */
      text-align: center;
      padding: 0px 5px;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.data {
      width: 10% !important;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.contato {
      width: 26.6666% !important;
      text-align: left !important;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.pet {
      width: 26.6666% !important;
      text-align: left !important;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.veiculo {
      width: 26.6666% !important;
      text-align: left !important;
    }
    /* .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.contato {
      width: 100% !important;
    } */
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.pet,
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.veiculo {
      min-width: 150px;
      min-width: 180px;
    }
      .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.pet > .pet-obs {
        margin-top: 5px;
      }
        .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.pet > .pet-obs > div > span {
          font-weight: bold;
        }
      .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.contato > button,
      .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.pet > button,
      .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.veiculo > button {
        padding: 0px !important;
        margin: 0px !important;
        text-align: left !important;
        min-height: 22px !important;
        line-height: 22px !important;
      }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr.linha-itens-1 > td {
      padding-bottom: 4px;
    }
    
      .con-pro-painel > .con-pro-painel-tab > table > tr > td > table > tr > td.itens > table > tr > td.item > button {
        display: inline-block;
        width: auto !important;   
        margin-left: 0px; 
        padding-left: 0px; 
      }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table {
      width: 100% !important;
      border-collapse: separate;
      border-spacing: 0px 2px;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td {
      vertical-align: middle;
      text-align: center;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
</style>

<style>
.con-pro-painel > .con-pro-painel-tab > table > tr > td.editar > button > span > img,
.con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.editar > button > span > img,
.con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.editar-geral > button > span > img {
  width: 13px;
  height: 13px;
}
.con-pro-painel > .con-pro-painel-tab > table > tr > td.venda > div > button > span:not(.cpnt-icone) {
  vertical-align: -2px;
}
.con-pro-painel > .con-pro-painel-tab > table > tr > td.venda > div > button > span > img {
  width: 13px;
  height: 13px;
  margin-right: 5px;
}

.con-pro-painel > .con-pro-painel-tab > table > tr > td.status,
.con-pro-painel > .con-pro-painel-tab > table > tr > td > table  > tr > td > table > tr > td.status > div > span > img {
  margin-left: 3px;
}
</style>

<script>
  // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
  const FUN_VERIFICA_COR_LETRA = require('@/assets/js/Funcoes-Gerais.js').FUN_VERIFICA_COR_LETRA

  // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
  const FUN_CRIAR_FRASE_TEMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_CRIAR_FRASE_TEMPO

  export default {
    components: {
      'RF-Tabela-Minha-Personalizacao': () => import('@/components/rf-geral/tabela/RF-Tabela-Minha-Personalizacao.vue'),
      'App-Demanda-Inserir-Item-Dialog': () => import('@/components/demanda/Editar/Demanda-Inserir-Item-Dialog.vue'),
      'App-Filtro-Relatorio': () => import('@/components/_geral/Filtro-Relatorio.vue'),
      'App-Controle-Processo-Painel-Detalhe-Tipo': () => import('@/components/controle-processo/painel/Controle-Processo-Painel-Detalhe-Tipo.vue'),
      'App-Controle-Processo-Editar-Varios': () => import('@/components/controle-processo/painel/Controle-Processo-Editar-Varios.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        mascara: true,
        pesquisa: null,
        dados: null,
        detalhe: null,
        placar: null,
        mostrarPlacar: [],
        mPer: null,
        adicionar: null,
        permissoes: {
          produto: false,
          servico: false
        },
        options: {
          lista: null,
          status: null,
          selecionado: []
        },
        filtros: {
          lista: '',
          status: '',
          busca: '',
          buscacompleta: false
        },
        pco_editar: null
      }
    },
    mounted: function () {
      this.conProPainelIniciar()
    },
    destroy: function () {
      this.conProPainelSetarStopLoop()
    },
    methods: {
      conProPainelSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conProPainelSetarStartLoop: function () {
        this.pesquisa = setInterval(() => {
          if ([ 'pco_painel', 'pco_painel_form' ].indexOf(this.$route.name) !== -1) {
            this.conProPainelBuscarRegistros()
          } else {
            this.conProPainelSetarStopLoop()
          }
        }, 30000)
      },
      conProPainelSetarStopLoop: function () {
        clearInterval(this.pesquisa)
      },
      conProPainelAtualizarData: function (indexV, indexI = null, tentativa = 0) {
        if (tentativa <= 50) {
          setTimeout(() => {
            // VERIFICA QUAL VALOR DEVE VOLTAR
            if (indexI === null) {
              // SETA O VALOR NA VARIAVEL
              this.dados[indexV].tempo = FUN_CRIAR_FRASE_TEMPO(this.dados[indexV].last_at_ptbr, this.dados[indexV].last_user)
              
              // VERIFICA SE A VARIAVEL FOI PREENCHIDA
              if ([ '', null, undefined ].indexOf(this.dados[indexV].tempo) !== -1) {
                this.conProPainelAtualizarData(indexV, indexI, (tentativa + 1))
              }
            } else {
              // SETA O VALOR NA VARIAVEL
              this.dados[indexV].itens[indexI].tempo = FUN_CRIAR_FRASE_TEMPO(this.dados[indexV].itens[indexI].last_at_ptbr, this.dados[indexV].itens[indexI].last_user)

              // VERIFICA SE A VARIAVEL FOI PREENCHIDA
              if ([ '', null, undefined ].indexOf(this.dados[indexV].itens[indexI].tempo) !== -1) {
                this.conProPainelAtualizarData(indexV, indexI, (tentativa + 1))
              }
            }
          }, 500)
        }
      },
      conProPainelReiniciar: function () {
        // PARA O PROCESSO DE CARREGAMENTO
        this.conProPainelSetarStopLoop()

        // INICIA O CARREGAMENTO DOS DADOS
        this.conProPainelBuscarRegistros()

        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // INICIA O PROCESSO DE CARREGAMENTO
        setTimeout(() => { this.conProPainelSetarStartLoop() }, 500)
      },
      conProPainelIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.conProPainelSetarStatusGeral('carregando')

        // CARREGAR A MINHA PERSONALIZAÇÃO
        this.conProPainelMperIniciar()

        // SETA AS PERMISSOES DE ACESSO
        this.permissoes.produto = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 17 ], 'and', [ 10, 12 ], 'and', null, null, false) === true
        this.permissoes.servico = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15, 17 ], 'and', [ 10, 25 ], 'and', null, null, false) === true

        // FAZ A BUSCA DOS REGISTROS NO BANCO DE DADOS
        this.conProPainelBuscarRegistros(() => {
          // SETA O STATUS DA PAGINA
          this.conProPainelSetarStatusGeral('')

          // INICIA O PROCESSO DE CARREGAMENTO
          setTimeout(() => { this.conProPainelSetarStartLoop() }, 500)
        })
      },
      conProPainelMontarFiltroBusca: function (callback = null, passo = 1, pesquisa = {}) {
        if (passo < 2) {
          if (this.filtros.lista !== '' || this.filtros.status !== '') {
            this.conProPainelBuscarStatus((registros) => {
              // INICIA O VETOR
              pesquisa.id_pco_status_item = []

              // ADICIONA TODOS OS IDS NO VETOR
              for (var indexS2 in registros) {
                // INICIA O VETOR
                var options = []

                // VERIFICA SE TEM ALGUM VALOR SELECIONADO
                if (this.filtros.lista !== '' && this.filtros.status === '') {
                  options = registros[indexS2].options
                } else {
                  options = registros[indexS2].options.filter(item => this.filtros.status.indexOf(item.id) !== -1)                    
                }

                // ADICIONA TODOS OS OPTIONS ENCONTRADO
                for (var indexO in options) {
                  pesquisa.id_pco_status_item.push(options[indexO].id)
                }
              }

              // FINALIZA O PROCESSO
              this.conProPainelMontarFiltroBusca(callback, (Number(passo) + 1), pesquisa)
            }, '', true)
          } else {
            this.conProPainelMontarFiltroBusca(callback, (Number(passo) + 1), pesquisa)
          }
        } else if (passo < 3) {
          if ([ '', null, undefined ].indexOf(this.filtros.lista) === -1) {
            if (this.filtros.lista !== '' && this.filtros.status === '') {
              this.conProPainelBuscarStatus((registros) => {
                // INICIA O VETOR
                pesquisa.id_pco_status_item = []
  
                // ADICIONA TODOS OS IDS NO VETOR
                for (var indexS2 in registros) {
                  // INICIA O VETOR
                  var options = []

                  // VERIFICA SE TEM ALGUM VALOR SELECIONADO
                  options = registros[indexS2].options

                  // ADICIONA TODOS OS OPTIONS ENCONTRADO
                  for (var indexO in options) {
                    pesquisa.id_pco_status_item.push(options[indexO].id)
                  }
                }

                // FINALIZA O PROCESSO
                this.conProPainelMontarFiltroBusca(callback, (Number(passo) + 1), pesquisa)
              }, '', true)
            } else {
              pesquisa.id_pco_status_item = this.filtros.status
            }
          } else {
            this.conProPainelMontarFiltroBusca(callback, (Number(passo) + 1), pesquisa)
          }
        } else if (passo < 4) {
          // VERIFICA SE TEM ALGUM ITEM PARA VERIFICAR
          if ([ '', null, undefined ].indexOf(this.filtros.busca) === -1) {
            pesquisa.busca_tipo = this.filtros.buscacompleta === true ? 'completa' : 'padrao'
            pesquisa.busca = this.filtros.busca
          }

          // FINALIZA O PROCESSO
          this.conProPainelMontarFiltroBusca(callback, (Number(passo) + 1), pesquisa)
        } else {
          callback(pesquisa)
        }
      },
      conProPainelBuscarRegistros: function (callback = null) {
        new Promise((success) => {
          // INICIA A VARIAVEL QUERYGET
          var queryGet = {}
          var requests = {}
          
          // MONTA OS FILTROS INFORMADOS
          this.conProPainelMontarFiltroBusca((filtros) => {
            // FORMATA O VALOR MONTADO
            queryGet.parametro = filtros

            // SETA A ROTA QUE DEVE CHAMAR
            queryGet.rota = '/con-processo/get2/'
  
            // SETA O METHOD QUE DEVE ENVIAR
            queryGet.metodo = 'GET'
  
            // SETA A BUSCA DE DADOS NO BANCO DE DADOS
            requests.geral = JSON.parse(JSON.stringify(queryGet))
            
            // FAZ A BUSCA DO FILTRO
            if (Object.keys(filtros).length >= 1) {
              // SETA A BUSCA ADICIONAL
              requests.placar = JSON.parse(JSON.stringify(queryGet))

              // LIMPA OS PARAMETROS PARA BUSCAR SEM FILTRO PARA O PLACAR 
              requests.placar.parametro = {}
            }
  
            // FINALIZA O CARREGAMENTO
            success(requests)
          }, 1)    
        }).then((requests) => {
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/rota-multipla', 'POST', requests, (retorno) => {
            // TRATA OS REGISTRO RECEBIDOS
            for (var indexV in retorno.geral.data) {
              // INICIA A VARIAVEL
              if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].cod_venda_id_pet_obs) === -1) {
                // SETA O TEXTO tela
                retorno.geral.data[indexV].cod_venda_id_pet_obs_tela = ''

                // SETA O TAMANHO DO TEXTO
                var tamanho = 20

                // SETA O TEXTO QUE DEVE MOSTRAR
                if (retorno.geral.data[indexV].cod_venda_id_pet_obs.length >= tamanho) {
                  retorno.geral.data[indexV].cod_venda_id_pet_obs_tela = retorno.geral.data[indexV].cod_venda_id_pet_obs.substring(0, tamanho) + '...'
                } else {
                  retorno.geral.data[indexV].cod_venda_id_pet_obs_tela = retorno.geral.data[indexV].cod_venda_id_pet_obs
                }

                // SETA O STATUS DO BOTÃO
                retorno.geral.data[indexV].cod_venda_id_pet_obs_mostrar_bt = retorno.geral.data[indexV].cod_venda_id_pet_obs_tela !== retorno.geral.data[indexV].cod_venda_id_pet_obs
                
                // VERIFICA SE O B0TÃO JA TA ABERTO
                if (retorno.geral.data[indexV].cod_venda_id_pet_obs_mostrar_bt === true) {
                  retorno.geral.data[indexV].cod_venda_id_pet_obs_mostrar_bt = this.options.selecionado.indexOf(retorno.geral.data[indexV].id) === -1 
                }
                
                // SETA O VALOR QUE DEVE MOSTRAR 
                if (retorno.geral.data[indexV].cod_venda_id_pet_obs_mostrar_bt === false) {
                  retorno.geral.data[indexV].cod_venda_id_pet_obs_tela = retorno.geral.data[indexV].cod_venda_id_pet_obs
                }
              }              

              // INICIA A VARIAVEL SE ELA NÃO FOI RECEBIDA
              if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].obs) !== -1) {
                retorno.geral.data[indexV].obs = []
              }

              // CALCULA A COR DA LETRA
              if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].id_pco_status_item_cor) === -1) {
                retorno.geral.data[indexV].id_pco_status_item_cor_letra = FUN_VERIFICA_COR_LETRA(retorno.geral.data[indexV].id_pco_status_item_cor)
              }

              // CALCULA O TEMPO DA ULTIMA ATUALIZAÇÃO
              if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].last_at_ptbr) === -1) {
                retorno.geral.data[indexV].tempo = FUN_CRIAR_FRASE_TEMPO(retorno.geral.data[indexV].last_at_ptbr, retorno.geral.data[indexV].last_user)
              }

              // VERIFICA SE TEM ITENS NA VENDA
              if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].itens) === -1 && retorno.geral.data[indexV].itens.length >= 1) {
                // LIMPA O VALOR RECEBIDO
                if (retorno.geral.data[indexV].itens[0] === '') {
                  retorno.geral.data[indexV].itens = []
                }

                for (var indexI in retorno.geral.data[indexV].itens) {
                  // SETA AS QUANTIDADES RECEBIDAS FORMATADAS
                  if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].itens[indexI].id_ven_pro_qtde) === -1) {
                    retorno.geral.data[indexV].itens[indexI]._id_ven_pro_qtde = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', retorno.geral.data[indexV].itens[indexI].
                    id_ven_pro_qtde)
                  }
                  if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].itens[indexI].id_ven_ser_qtde) === -1) {
                    retorno.geral.data[indexV].itens[indexI]._id_ven_ser_qtde = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', retorno.geral.data[indexV].itens[indexI].
                    id_ven_ser_qtde)
                  }

                  // INICIA A VARIAVEL SE ELA NÃO FOI RECEBIDA
                  if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].itens[indexI].obs) !== -1) {
                    retorno.geral.data[indexV].itens[indexI].obs = []
                  }

                  // CALCULA A COR DA LETRA
                  if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].itens[indexI].id_pco_status_item_cor) === -1) {
                    retorno.geral.data[indexV].itens[indexI].id_pco_status_item_cor_letra = FUN_VERIFICA_COR_LETRA(retorno.geral.data[indexV].itens[indexI].id_pco_status_item_cor)
                  }

                  // CALCULA O TEMPO DA ULTIMA ATUALIZAÇÃO
                  if ([ '', null, undefined ].indexOf(retorno.geral.data[indexV].itens[indexI].last_at_ptbr) === -1) {
                    retorno.geral.data[indexV].itens[indexI].tempo = FUN_CRIAR_FRASE_TEMPO(retorno.geral.data[indexV].itens[indexI].last_at_ptbr, retorno.geral.data[indexV].itens[indexI].last_user)
                  }
                }
              }
            }

            // LIMPA OS DADOS DO VETOR
            // this.dados = null
            this.mascara = true

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // CARREGA OS DADOS
            setTimeout(() => {
              // SETA OS VALORES RECEBIDOS PARA PARTE GERAL
              if ([ '', null, undefined ].indexOf(retorno.geral) === -1) {
                this.dados = retorno.geral.data
              }

              // INICIA A VARIAVEL DO PLACAR
              var placar = null

              // SETA OS VALORES RECEBIDOS PARA PARTE GERAL
              if ([ '', null, undefined ].indexOf(retorno.placar) !== -1) {
                placar = retorno.geral.data
              } else {
                placar = retorno.placar.data
              }

              // CHAMA A FUNÇAO PARA SETAR OS DADOS NO PLACAR
              this.conProPainelAtualizarPlacar(JSON.parse(JSON.stringify(placar)))

              // LIBERA A MASCARA
              this.mascara = false

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // EXECUTA O CALLBACK RECEBIDO
              if (callback !== null && typeof callback === 'function') {
                callback()
              }
            }, 300)
          }, this.conProPainelSetarStatusGeral)
        })
      },
      conProPainelAbrirVenda: function (id) {
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'venda', id: id.toString(), tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
      },
      conProPainelAtualizarPlacar: function (vetor) {
        // INICIA O VETOR
        var placar = {}

        // RODA O VALO RECEBIDO PARA MONTAR O PLACAR
        for (var indexV in vetor) {
          if ([ '', null, undefined ].indexOf(vetor[indexV].id_pco_status) === -1) {
            // PEGA O NOME DA CHAVE QUE DE TRABALHAR
            var chaveV1 = vetor[indexV].id_pco_status
  
            // VERIFICA SE O VALOR JÁ FOI INICIADO
            if (placar[chaveV1] === undefined) {
              placar[chaveV1] = {
                id: vetor[indexV].id_pco_status,
                nome: vetor[indexV].id_pco_status_nome,
                qtde: 1,
                tabela: {}
              }
            } else {
              placar[chaveV1].qtde = Number(placar[chaveV1].qtde) + 1
            }
  
            // PEGA O NOME DA CHAVE QUE DE TRABALHAR
            var chaveI1 = chaveV1 + '__' + vetor[indexV].id_pco_status_item
  
            // VERIFICA SE O VALOR JÁ FOI INICIADO
            if (placar[chaveV1].tabela[chaveI1] === undefined) {
              placar[chaveV1].tabela[chaveI1] = {
                id: vetor[indexV].id_pco_status_item,
                nome: vetor[indexV].id_pco_status_item_nome,
                cor_letra: FUN_VERIFICA_COR_LETRA(vetor[indexV].id_pco_status_item_cor),
                cor_fundo: vetor[indexV].id_pco_status_item_cor,
                id_pco_status: vetor[indexV].id_pco_status,
                id_pco_status_nome: vetor[indexV].id_pco_status_nome,
                qtde: 1
              }
            } else {
              placar[chaveV1].tabela[chaveI1].qtde = Number(placar[chaveV1].tabela[chaveI1].qtde) + 1
            }
          }

          // VERIFICA SE TEM ITENS PARA CALCULAR
          if ([ '', null, undefined ].indexOf(vetor[indexV].itens) === -1 && vetor[indexV].itens.length >= 1) {
            for (var indexI in vetor[indexV].itens) {
              if ([ '', null, undefined ].indexOf(vetor[indexV].itens[indexI]) === -1) {
                // PEGA O NOME DA CHAVE QUE DE TRABALHAR
                var chaveV2 = vetor[indexV].itens[indexI].id_pco_status
      
                // VERIFICA SE O VALOR JÁ FOI INICIADO
                if (placar[chaveV2] === undefined) {
                  placar[chaveV2] = {
                    id: vetor[indexV].itens[indexI].id_pco_status,
                    nome: vetor[indexV].itens[indexI].id_pco_status_nome,
                    qtde: 1,
                    tabela: {}
                  }
                } else {
                  placar[chaveV2].qtde = Number(placar[chaveV2].qtde) + 1
                }

                // PEGA O NOME DA CHAVE QUE DE TRABALHAR
                var chaveI2 = chaveV2 + '__' + vetor[indexV].itens[indexI].id_pco_status_item
      
                // VERIFICA SE O VALOR JÁ FOI INICIADO
                if (placar[chaveV2].tabela[chaveI2] === undefined) {
                  placar[chaveV2].tabela[chaveI2] = {
                    id: vetor[indexV].itens[indexI].id_pco_status_item,
                    nome: vetor[indexV].itens[indexI].id_pco_status_item_nome,
                    cor_letra: FUN_VERIFICA_COR_LETRA(vetor[indexV].itens[indexI].id_pco_status_item_cor),
                    cor_fundo: vetor[indexV].itens[indexI].id_pco_status_item_cor,
                    id_pco_status: vetor[indexV].itens[indexI].id_pco_status,
                    id_pco_status_nome: vetor[indexV].itens[indexI].id_pco_status_nome,
                    qtde: 1
                  }
                } else {
                  placar[chaveV2].tabela[chaveI2].qtde = Number(placar[chaveV2].tabela[chaveI2].qtde) + 1
                }
              }
            }
          }
        }

        // SETA O VALOR MONTADO
        this.placar = placar

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conProPainelAbrirPainel: function (id) {
        // PEGA A POSIÇÃO DO VALOR NO VETOR
        var posicao = this.mostrarPlacar.indexOf(id)

        // SETA OS DADOS RECEBIDOS
        if (posicao !== -1) {
          this.mostrarPlacar.splice(posicao, 1)
          
          if (this.filtros.lista !== '' && this.filtros.lista.length >= 1) {
            this.filtros.lista = this.filtros.lista.filter(item => item !== id)
          } else if (this.filtros.lista !== '') {
            this.filtros.lista = ''
          }
        } else {
          if (this.filtros.lista === '') {
            this.filtros.lista = []
          }

          this.mostrarPlacar.push(id)
          this.filtros.lista.push(id)

        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conProPainelAbrirDetalhe: function (tipo) {
        // SETA OS DADOS RECEBIDOS
        this.detalhe = tipo

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conProPainelAbrirContato: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'contato', id: id.toString() }

        // SETA A FUNÇÃO CALLBACK
        params.callback = this.conProPainelInformacoesCadastroFechar

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      conProPainelAbrirPet: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'pet', id: id.toString() }

        // SETA A FUNÇÃO CALLBACK
        params.callback = this.conProPainelInformacoesCadastroFechar

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      conProPainelAbrirVeiculo: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'veiculo', id: id.toString() }

        // SETA A FUNÇÃO CALLBACK
        params.callback = this.conProPainelInformacoesCadastroFechar

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      conProPainelAbrirProcesso: function (id, tipo) {
        this.$router.push({ name: 'pco_painel_form', params: { cts: this.$store.state.token.cts, tipo: tipo, id: id } })
      },
      conProPainelAbrirProduto: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'produto', id: id.toString() }

        // SETA A FUNÇÃO CALLBACK
        params.callback = this.conProPainelInformacoesCadastroFechar

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      conProPainelAbrirServico: function (id) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'servico', id: id.toString() }

        // SETA A FUNÇÃO CALLBACK
        params.callback = this.conProPainelInformacoesCadastroFechar

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      conProPainelInformacoesCadastroFechar: function (atualizar) {
        if (atualizar === true) {
          this.conProPainelReiniciar()
        }
      },
      conProPainelMperIniciar: function (callback = null) {
        // INICIA A VARIAVEL
        var model = 'PcoPainel'

        // LIMPA OS DADOS DA MINHA PERSONALIZAÇÃO
        this.mPer = {}

        // VERIFICA SE FOI RECEBIDO OS DADOS DA MINHA PERSONALZIAÇÃO
        if (!this.$store.state.mPer.hasOwnProperty(model)) {
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/config/mper/get/', 'GET', model, (retorno) => {

            // SALVA A MINHA PERSONALIZAÇÃO RECEBIDA DA API
            this.$store.commit('SET_MINHA_PERSONALIZACAO', { id: model, dados: retorno.data })

            // CHAMA A FUNÇÃO PARA INICIAR NOVAMENTE
            this.conProPainelMperIniciar()
          }, this.conProPainelSetarStatusGeral)
        } else {
          // SETA OS DADOS DA MINHA PERSONALIZAÇÃO
          var mPer = {
            model: model,
            rpp: false,
            order: false,
            field: [
              { mper: 1, chave: 'dt_venda',           nome: 'Dt. Venda'           },
              { mper: 1, chave: 'dt_vcto',            nome: 'Vencimento'          },
              { mper: 1, chave: 'qtde',               nome: 'Quantidade Itens'    },
              { mper: 1, chave: 'comentarios_pro',    nome: 'Observação Itens'    },
              { mper: 1, chave: 'comentarios_ven',    nome: 'Observação Venda'    }
            ],
            mostrarCol: []
          }

          for (var index1 in mPer.field) {
            // VERIFICA SE DEVE MOSTRAR O CAMPO
            if ([ '', null, undefined ].indexOf(this.$store.state.mPer[model].field) === -1) {
              mPer.field[index1].mper = this.$store.state.mPer[model].field.indexOf(mPer.field[index1].chave) === -1 ? 0 : 1
            }

            // MARCA AS COLUNAS QUE DEVEM SER MOSTRADAS
            if (mPer.field[index1].mper >= 1) {
              mPer.mostrarCol.push(mPer.field[index1].chave)
            }
          }

          // SETA O VALOR ATUALIZADO
          this.mPer = mPer

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
      conProPainelCalcularColspanTabelaItens: function () {
        // INICIA O COLSPAN
        var colspan = 5

        // // VERIFICA SE TEM A COLUNA PET
        // colspan += [ '', null, undefined ].indexOf(this.mPer.mostrarCol) === -1 && this.mPer.mostrarCol.indexOf('dt_venda') !== -1 ? 1 : 0

        // // VERIFICA SE TEM A COLUNA PET
        // colspan += [ '', null, undefined ].indexOf(this.mPer.mostrarCol) === -1 && this.mPer.mostrarCol.indexOf('dt_vcto') !== -1 ? 1 : 0

        // // VERIFICA SE TEM A COLUNA PET
        // colspan += [ '', null, undefined ].indexOf(linha.cod_venda_id_pet) === -1 ? 1 : 0

        // // VERIFICA SE TEM A COLUNA PET OBS
        // colspan += [ '', null, undefined ].indexOf(linha.cod_venda_id_pet_obs) === -1 ? 1 : 0

        // // VERIFICA SE TEM A COLUNA VEICULO
        // colspan += [ '', null, undefined ].indexOf(linha.cod_venda_id_vei) === -1 ? 1 : 0

        // RETORNA O VALOR MONTADO
        return colspan
      },
      conProPainelAdicionarItemVendaIniciar: function (cod_venda, tipo) {
        // SETA OS PARAMETROS PARA ADICONAR ITENS NA VENDA
        this.adicionar = { vendaId: cod_venda, tipo: tipo }

        // SETA A INICIALIZAÇÃO
        this.time = new Date().getTime()
      },
      conProPainelAdicionarItemVendaFechar: function (atualizar) {
        // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
        this.conProPainelInformacoesCadastroFechar(atualizar)

        // SETA OS PARAMETROS PARA ADICONAR ITENS NA VENDA
        this.adicionar = null

        // SETA A INICIALIZAÇÃO
        this.time = new Date().getTime()
      },
      conProPainelAlterarObservaçãoPet(indexL) {
        // ALTERA OS VALORES DAS VARIAVEIS
        this.dados[indexL].cod_venda_id_pet_obs_mostrar_bt = false
        this.dados[indexL].cod_venda_id_pet_obs_tela = this.dados[indexL].cod_venda_id_pet_obs

        // ADICIONA O ID AO VETOR
        this.options.selecionado.push(this.dados[indexL].id)
      },
      conProPainelAtualizarFiltro: function (value, chave) {
        // SETA O NOVO VALOR DO FILTRO
        this.filtros[chave] = value

        // VERIFICA A AÇÃO PERSONALIZADA QUE DEVE REALIZAR
        switch (chave) {
          case 'lista':
            this.options.lista = []
            this.filtros.status = ''
            break
            
          case 'status':
            this.options.status = []
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conProPainelBuscarLista: function (callback) {
        // INICIA O CARREGAMENTO
        var registros = {}

        // RODA O VETOR PEGANDO OS VALORES 
        for (var indexV in this.placar) {
          registros[indexV] = { id: this.placar[indexV].id, nome: this.placar[indexV].nome, qtde: this.placar[indexV].qtde }
        }

        // CONVERTE O VALOR E ARRAY
        registros = Object.values(registros)

        // EXECUTA O CALLBACK RECEBIDO
        callback(registros)
      },
      conProPainelBuscarStatus: function (callback) {
        // INICIA O CARREGAMENTO
        var registros = {}

        // RODA O VETOR PEGANDO OS VALORES 
        for (var indexV in this.placar) {
          if (this.filtros.lista === '' || this.filtros.lista.indexOf(indexV) !== -1) {
            registros[indexV] = { optgroup: this.placar[indexV].nome, options: Object.values(this.placar[indexV].tabela) }
          }
        }

        // CONVERTE O VALOR E ARRAY
        registros = Object.values(registros)

        // EXECUTA O CALLBACK RECEBIDO
        callback(registros)
      },
      conProPainelEditarGeralProcesso: function (vetor) {
        if (vetor.length === 1) {
          this.conProPainelAbrirProcesso(([ "", null, undefined ].indexOf(vetor[0].id_ven_pro) === -1 ? vetor[0].id_ven_pro : vetor[0].id_ven_ser), ([ '', null, undefined ].indexOf(vetor[0].id_ven_ser) === -1 ? 'servico' : 'produto'))
        } else {
          // INICIA A VARIAVEL
          var params = { tipo: '', ids: [] }
  
          // PEGA OS VALORES
          for (var indexI in vetor) {
            // SETA O TIPO DE REGISTRO
            if (indexI === 0 || indexI === '0') {
              params.tipo = ([ '', null, undefined ].indexOf(vetor[indexI].id_ven_ser) === -1 ? 'servico' : 'produto')
            }

            // ADICIONA O ID DO REGISTRO
            params.ids.push(([ "", null, undefined ].indexOf(vetor[indexI].id_ven_pro) === -1 ? vetor[indexI].id_ven_pro : vetor[indexI].id_ven_ser))
          }

          // INICIA A VARIAVEL
          this.pco_editar = params  
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      conProPainelFecharAlteracaoProcesso: function (atualizar) {
        // LIMPA O CAMPO PARA CHEGAR A JANELA
        this.pco_editar = null

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE ATUALIZAR A TABELA
        if (atualizar === true) {
          this.conProPainelReiniciar()
        }
      }
    }
  }
</script>
